module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modal-title": 'Edit Filter'
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": _vm.close
    }
  }, [_c('FormulateForm', [_c('FormulateInput', {
    attrs: {
      "type": "checkbox",
      "label": "Active"
    },
    model: {
      value: (_vm.model.active),
      callback: function($$v) {
        _vm.$set(_vm.model, "active", $$v)
      },
      expression: "model.active"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "checkbox",
      "label": "Accept leads matching this rule"
    },
    model: {
      value: (_vm.model.exclude),
      callback: function($$v) {
        _vm.$set(_vm.model, "exclude", $$v)
      },
      expression: "model.exclude"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "range",
      "label": "Rate",
      "min": "0",
      "max": "100",
      "validation": "required|min:0|max:100",
      "show-value": "true"
    },
    model: {
      value: (_vm.model.rate),
      callback: function($$v) {
        _vm.$set(_vm.model, "rate", $$v)
      },
      expression: "model.rate"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "text",
      "label": "Notes"
    },
    model: {
      value: (_vm.model.notes),
      callback: function($$v) {
        _vm.$set(_vm.model, "notes", $$v)
      },
      expression: "model.notes"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "text",
      "label": "API Response"
    },
    model: {
      value: (_vm.model.api_response),
      callback: function($$v) {
        _vm.$set(_vm.model, "api_response", $$v)
      },
      expression: "model.api_response"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e235a1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/FilterModal.vue
// module id = 659
// module chunks = 0